package com.patronat.top.features.dashboard.domain.usecase.command

data class ReplyToOwnerReviewCommand(
    val reviewId: String,
    val text: String
)
